module.exports = __webpack_public_path__ + "static/media/logout.e5d2f378.svg";